<template>
  <div class="field">
    <div class="control">
      <label class="checkbox">
        <input
          :value="value"
          @change="updateValue"
          type="checkbox"
          :disabled="disabled"
        >
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
// import { elementMixin } from "./formMixins";

export default {
  name: 'checkbox',
  // mixins: [elementMixin],
  props: {
    value: { type: Boolean, required: true },
    disabled: { type: Boolean, required: false, default: false },
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/all";
@import "~bulma/sass/base/all";
@import "~bulma/sass/elements/form.sass";
</style>
